import React from "react";

type Props = {
  label: string;
  onFileAttached: (event: React.ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  multiple?: boolean;
  hasName?: boolean;
  isBoxed?: boolean;
  attachedFileName?: string;
  loading?: boolean;
  disabled?: boolean;
  shouldDisplayError?: boolean;
  errorMsg?: string;
};

export const FileInput: React.FC<Props> = ({
  label,
  onFileAttached,
  accept,
  hasName = false,
  isBoxed = false,
  multiple = false,
  attachedFileName,
  loading,
  disabled = false,
  shouldDisplayError = false,
  errorMsg,
}) => {
  const isError = errorMsg && errorMsg !== "";
  return (
    <div>
      <div
        className={`file is-fullwidth ${hasName ? "has-name " : " "} ${
          isBoxed ? "is-boxed " : " "
        } ${isError && shouldDisplayError ? "is-danger " : " "}`}
      >
        <label className="file-label">
          <input
            className="file-input"
            type="file"
            accept={accept}
            onChange={onFileAttached}
            multiple={multiple}
            disabled={disabled}
          />
          <span className="file-cta">
            <span className="file-icon">
              <i className="fas fa-upload"></i>
            </span>
            <span className="file-label">{label}</span>
          </span>
          {hasName &&
            typeof attachedFileName === "string" &&
            attachedFileName !== "" && (
              <span className="file-name">{attachedFileName}</span>
            )}
          {loading && (
            <progress
              className="progress is-small is-primary"
              style={{ position: "absolute" }}
              max="100"
            >
              15%
            </progress>
          )}
        </label>
      </div>
      {isError && shouldDisplayError && (
        <p className="help has-text-weight-normal is-danger">{errorMsg}</p>
      )}
    </div>
  );
};

export default FileInput;
